export default "__VITE_ASSET__cjY4rqtN__"